import { COMMANDS } from '../Select'

export const clearOptionsFn = (
  options: (
    | string
    | number
    | {
        value?: string | number | null
        [name: string]: any;
      }
  )[],
) => options.filter((o) => !Object.values(COMMANDS).includes(String(typeof o === 'object' ? o?.value : o)))
